$(document).ready(function () {

  // Replace compare at price from product options
  const observer = new MutationObserver(checkForElement)
  const config = { childList: true, subtree: true }
  observer.observe(document.body, config)
  function checkForElement() {
    const hostElement = document.querySelector('.mw-option__control--type-select')
    if (hostElement) {
      observer.disconnect() // Stop the MutationObserver
      function fixOptionText(selectElement) {
        const compareAtRegex = /\(Compare at: .+\)/;
        selectElement.find('option').each(function() {
          const optionText = $(this).text();
          if (compareAtRegex.test(optionText)) {
            const fixedText = optionText.replace(compareAtRegex, '');
            $(this).text(fixedText);
          }
        });
      }
      $('.mw-option__control--type-select').each(function() {
        fixOptionText($(this));
      });
      $('.mw-option__control--type-select').change(function() {
        fixOptionText($(this));
      });
    }
  }
  // End Replace compare at price from product options

  const carouselWrap = document.querySelectorAll('.block__featured-collection-slider')
  carouselWrap && carouselWrap.forEach(carouselAll => {
    new Swiper(carouselAll, {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.block__featured-collection-arrows-right',
        prevEl: '.block__featured-collection-arrows-left',
      },
      pagination: {
        el: ".block__featured-collection-scrollbar",
        type: "progressbar",
      },
      breakpoints: {
        310: {
          slidesPerView: 1,
          spaceBetween: 15
        },
        350: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  });

  const FeaturedCollectionList = document.querySelectorAll('.block__featured-collection-list-slider')
  FeaturedCollectionList && FeaturedCollectionList.forEach(FeaturedCollectionListAll => {
    new Swiper(FeaturedCollectionListAll, {
      slidesPerView: 1.02,
      spaceBetween: 10,
      navigation: {
        nextEl: '.block__featured-collectionlist-arrows-right',
        prevEl: '.block__featured-collectionlist-arrows-left',
      },
      pagination: {
        el: ".block__featured-collectionlist-scrollbar",
        type: "progressbar",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  });

  if ($(window).width() <= 749) {
    $(document).on("click", ".block__new-footer-menu-listing-heading", function () {
      $(this).parents(".block__new-footer-menu-listing").toggleClass("active");
      $(this).parents(".block__new-footer-menu-listing").find(".footer-block__details-content").slideToggle();
    });
  }

  // Faq -----------------------------------------------------------------------------------------------------
  $('.faq__accordion details').on('click', function () {
    $(this).attr('open');
    $(this).parent('.faq__accordion').siblings().find('details').removeAttr('open');
  });

  // Related Blog posts --------------------------------------------------------------------------
  const RelateBlogList = document.querySelectorAll('.block__featured-blog-list-slider')
  RelateBlogList && RelateBlogList.forEach(RelateBlogListAll => {
    new Swiper(RelateBlogListAll, {
      slidesPerView: 1.15,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.block__featured-blog-arrows-right',
        prevEl: '.block__featured-blog-arrows-left',
      },
      pagination: {
        el: ".block__featured-blog-scrollbar",
        type: "progressbar",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false
        }
      }
    });
  });

  // Oriflamme product page video section
  var oriflammeVideocarouselWrap = document.querySelectorAll('.block__oriflamme-video-contentwrap')
  oriflammeVideocarouselWrap && oriflammeVideocarouselWrap.forEach(oriflammeVideocarouselAll => {
  new Swiper(oriflammeVideocarouselAll, {
      slidesPerView:1.1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.block__oriflamme-video-arrows-right',
        prevEl: '.block__oriflamme-video-arrows-left',
      },
      on: {
        transitionStart: function(){         
          var videos = document.querySelectorAll('.block__oriflamme-video video');
          Array.prototype.forEach.call(videos, function(video){
            video.pause();
          });
        },
        
        transitionEnd: function(){
          var activeIndex = this.activeIndex;
          var activeSlide = document.getElementsByClassName('block__oriflamme-video-wrap')[activeIndex];
          var activeSlideVideo = activeSlide.querySelector('.block__oriflamme-video-element');
          activeSlideVideo.play();
        },
      },
      breakpoints: {
          350: {
            slidesPerView: 1.1
          },
          575: {
            slidesPerView: 1.4
          },
          990: {
            slidesPerView: 1.5,
            centeredSlides: true,
            spaceBetween: 20
          },
          1460: {
            slidesPerView: 1.7,
            centeredSlides: true,
            spaceBetween: 20
          }
      }
    });
  });

  // product page purchase entire set section
  const ProductPurchaseSet = document.querySelectorAll('.product-purchaseset-skulistwrapper')
  ProductPurchaseSet && ProductPurchaseSet.forEach(ProductPurchaseSetAll => {
    new Swiper(ProductPurchaseSetAll, {
      slidesPerView: 1.50,
      spaceBetween: 12,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: '.product-purchaseset-arrows-right',
        prevEl: '.product-purchaseset-arrows-left',
      },
      breakpoints: {
        575: {
          slidesPerView: 2.3
        },
        750: {
          slidesPerView: 3
        },
        990: {
          slidesPerView: 1.2
        },
        1200: {
          slidesPerView: 2
        },
        1461: {
          slidesPerView: 2.3
        }
      }
    });
  });

  // Oriflamme product page community section
  var oriflammeCommunitycarouselWrap = document.querySelectorAll('.block__oriflamme-community-wrapper')
  oriflammeCommunitycarouselWrap && oriflammeCommunitycarouselWrap.forEach(oriflammeCommunitycarouselAll => {
  new Swiper(oriflammeCommunitycarouselAll, {
      slidesPerView:1.3,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
          390: {
            slidesPerView: 3.2
          },
          750: {
            slidesPerView: 4.2,
            spaceBetween: 16
          },
          1200: {
            slidesPerView: 4.5,
            spaceBetween: 16
          },
          1460: {
            slidesPerView: 4.7,
            spaceBetween: 16
          }
      }
    });
  });


  // product card swatches
  jQuery('.cardproduct-swatch-color').click(function (e) {
    e.preventDefault();
    var current_img_val = $(this).attr('data-colorimg'),
      current_swatch_producttitle = $(this).attr('swatchproduct'),
      swatch_img_html = `<img srcset="${current_img_val}&amp;width=165 165w,
      ${current_img_val}&amp;width=360 360w,
      ${current_img_val}&amp;width=533 533w,
      ${current_img_val}&amp;width=720 720w,
      ${current_img_val}&amp;width=940 940w,
      ${current_img_val}&amp;width=1066 1066w,
      ${current_img_val} 1200w" 
      src="${current_img_val}&amp;width=533" 
      sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" 
      alt="${current_swatch_producttitle}" class="motion-reduce" loading="lazy" width="1200" height="1200">`;
    if (current_img_val) {
      $(this).parents('.product-card-wrapper').find('.card__media .media').html(swatch_img_html);
      $(this).parents('.product-card-wrapper').find('.cart_product_imagewrap').html(swatch_img_html);
    } else { }
  });

  //Product swatches change
  $('.product-variant-radiowrapper .product-form__input input').change(function(){
    var selected_val = $(this).val();
    $(this).parents('.product-variant-radiowrapper .product-form__input').find('.form__label .product-form-input-selectedval').text('('+selected_val+')');
  });

  // Megamenu open
  $(".block__header--megamenu-list").on('hover mouseenter touchstart', function(e) {
    $('body').addClass('menuopen');
    }, function(){
    $('body').removeClass('menuopen');
  });
  $(".block__header--megamenu-list").on('mouseleave touchend', function(e) {
    $('body').removeClass('menuopen');
  });


  //  My Account page Tabbing
  const account_address_tab = localStorage.getItem("account_address");
  const account_current_tab = localStorage.getItem("current_tab");
  var protocol = window.location.href;
  var isAddress = protocol.includes("addresses");

  console.log(account_current_tab,"account_current_tab Outer");
  
  if (isAddress) {
    $('.main_account-tabitem').removeClass('main_accounttab-active');
    $('.main_account-tabitem[data-accounttab="addresses"]').addClass('main_accounttab-active');
    $('.main_account_tabcontentwrap').removeClass('main_accounttabcontent-active');
    $('.main_account_tabcontentwrap[data-accounttabcontent="addresses"]').addClass('main_accounttabcontent-active');
  } else {
    if(account_current_tab){
      $('.main_account-tabitem').removeClass('main_accounttab-active');
      $('.main_account-tabitem[data-accounttab="'+account_current_tab+'"]').addClass('main_accounttab-active');
      $('.main_account_tabcontentwrap').removeClass('main_accounttabcontent-active');
      $('.main_account_tabcontentwrap[data-accounttabcontent="'+account_current_tab+'"]').addClass('main_accounttabcontent-active');
      localStorage.removeItem("current_tab", account_current_tab);
      console.log(account_current_tab,"account_current_tab INNER");
      if(account_current_tab == 'loyalty'){
        $('.main_customer_account-loyaltybanner').addClass('active-loyaltybanner').css('display','block');
      }else{
        $('.main_customer_account-loyaltybanner').removeClass('active-loyaltybanner').css('display','none');
      }
    } else {
      $('.main_account-tabitem:first-child').addClass('main_accounttab-active');
      $('.main_account_ordertab-content').addClass('main_accounttabcontent-active');
    }
  }

  $('.main_account-tabitem:not(.main_account-tabitemlogout):not(.main_account-tabitemaddresses)').click(function () {
    var current_accounttab = $(this).attr('data-accounttab');
    if(isAddress){
      localStorage.setItem("current_tab", current_accounttab);
    } else {
      localStorage.removeItem("current_tab", current_accounttab);
    }
    $('.main_account-tabitem').removeClass('main_accounttab-active');
    $(this).addClass('main_accounttab-active');
    $('.main_account_tabcontentwrap').removeClass('main_accounttabcontent-active');
    $('.main_account_tabcontentwrap[data-accounttabcontent="' + current_accounttab + '"]').addClass('main_accounttabcontent-active');
    if(current_accounttab == 'loyalty'){
      $('.main_customer_account-loyaltybanner').addClass('active-loyaltybanner').css('display','block');
    }else{
      $('.main_customer_account-loyaltybanner').removeClass('active-loyaltybanner').css('display','none');
    }

    if (!current_accounttab.includes('addresses')) {
      localStorage.removeItem('account_address');
    }
    
    $('.main_account-tab-mobilefilter').toggleClass('tab-filter-open');
    if ($(window).width() > 767) {
    } else {
      $('.main_account-tablist').slideToggle('500');
    }  
  });

  // Account page manage order button
  $(".main_account-manageorder").click(function(){
    $(this).parents('.main_account_orderhistory').find('.main_account_ordercontent-body').slideToggle();
    $(this).parents('.main_account_orderhistory').toggleClass("is-open");
  });

   //Account order status
   $('.main_account_statusbtn-txt').click(function(){
    console.log('clicked');
    $(this).parents('.main_account_statusbutton').toggleClass('status-active');
    $(this).parents('.main_account_orderitem').find('.main_account_order-stauswrapper').slideToggle();
  });

  //Account page mobile short filter
  $('.main_account-tab-mobilefilter').click(function(){
    $(this).toggleClass('tab-filter-open');
    $(this).siblings('.main_account-tablist').slideToggle('500');
  });

  if($(window).width() <= 767){
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.main_account-tabwrap').length) {
        $('.main_account-tab-mobilefilter').removeClass('tab-filter-open');
        $('.main_account-tab-mobilefilter').siblings('.main_account-tablist').slideUp('500');
      }
    });
  }else{}

  $("#RegisterForm-FirstName, #RegisterForm-LastName").on("input",function(event) {
    this.value = this.value.replace(/[0-9^*|\":<>[\]{}`\\()';@&$+-/.=!_%#]/g,"")
  });

  //Trade & commercial read our story
  const ReadArticleList = document.querySelectorAll('.block__readoutstory-articlewrap')
  ReadArticleList && ReadArticleList.forEach(ReadArticleListAll => {
    new Swiper(ReadArticleListAll, {
      slidesPerView: 1.50,
      centeredSlides: true,
      loop: true,
      spaceBetween: 12,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false
        }
      }
    });
  });

  // Collection page load more
  $(document).on("click", ".js-load-more", function () {
    var $this = $(this),
      totalPages = parseInt($("[data-all-pages]").val()),
      currentPage = parseInt($("[data-this-page]").val()),
      datacollurl = $("[data-coll-url]").val();
    $this.attr("disabled", true);
    $this.html("<span load-more-text></span>");
    setTimeout(function () {
      $this.addClass("loading_btn");
    }, 200);
      $this.find("[load-more-text]").addClass("hide");
      $this.find("[loader]").removeClass("hide");
      var nextUrl = $("[data-next-link]").val();
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;
      $.ajax({
        url: nextUrl,
        type: "GET",
        dataType: "html",
        success: function (responseHTML) {
          $("[data-next-link]").val(datacollurl + "?page=" + next_coll);
          $("[data-this-page]").val(current_page_new);
          $("#product-grid").append($(responseHTML).find("#product-grid").html());
        },
        complete: function () {
          if (current_page_new < totalPages) {
            $this.removeClass("loading_btn");
            $this.html("<span load-more-text></span>");
            $this.attr("disabled", false);
            $this.find("[load-more-text]").removeClass("hide");
            $this.find("[loader]").addClass("hide");
          }
          if (current_page_new >= totalPages) {
            $this.find("[load-more-text]").parents(".load-more_wrap").hide();
          }
        },
      });

      jQuery('.cardproduct-swatch-color').click(function (e) {
        e.preventDefault();
        console.log('click');
        var current_img_val = $(this).attr('data-colorimg'),
          current_swatch_producttitle = $(this).attr('swatchproduct'),
          swatch_img_html = `<img srcset="${current_img_val}&amp;width=165 165w,
          ${current_img_val}&amp;width=360 360w,
          ${current_img_val}&amp;width=533 533w,
          ${current_img_val}&amp;width=720 720w,
          ${current_img_val}&amp;width=940 940w,
          ${current_img_val}&amp;width=1066 1066w,
          ${current_img_val} 1200w" 
          src="${current_img_val}&amp;width=533" 
          sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" 
          alt="${current_swatch_producttitle}" class="motion-reduce" loading="lazy" width="1200" height="1200">`;
        if (current_img_val) {
          $(this).parents('.product-card-wrapper').find('.card__media .media').html(swatch_img_html);
        } else { }
      });
  });

  $( window ).on( "scroll", function() {
    var current_scroll = $(this).scrollTop();
    if($('#product-grid').length > 0){
      var productlist_div = $('#product-grid')[0].clientHeight - 500;
      if(current_scroll > productlist_div){
        $('.js-load-more').trigger('click');
      }else{}
    }
    
  });


$(".block__header--megamenu-list > a").click(function(event) {
  event.preventDefault();
  if($(this).parent().hasClass("custom_hover")) {
    $(this).parent().removeClass("custom_hover");
  } else {
    $(".block__header--megamenu-list").removeClass("custom_hover"); // Remove class from all list items
    $(this).parent().addClass("custom_hover");
  }
});

//check
   // Get the current URL
    var currentUrl = window.location.href;
  if(currentUrl.includes("/products/oriflamme-mediterranean-rectangle-gas-fire-table-1")){
    
  }else{
      $(".productpage-widget-section.productpage-addon-section").css('display','none');
  }

  if(currentUrl.includes("/products/oriflamme-")){
   
setTimeout(function() { console.log("dsdsdsd111113333344");
  $(".rebuy-widget-container").css("display", "none");
}, 3000);

  }else{
    
  }
 // if (window.location.href === "https://allbackyardfun.com/search.html?") {
 //            window.location.href = "https://allbackyardfun.com/search.html?q=all";
 //          }
  // if(currentUrl.includes("/search.html?")){
  //   window.location.href = "/search.html?q=all";
  // }
    // if(currentUrl.includes("/products/oriflamme")) {
    
    // }
  //end



  
});